import { Component, HostListener, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { listSortByDate, simyoDocStatus, superStatus, superStatusTranslate, typeCard } from 'src/app/shared/constantes';
import { SimyoService } from 'src/app/simyo/services/simyo.service';
import * as moment from 'moment/moment';
import { UserNotFoundComponent } from 'src/app/shared/components/user-not-found/user-not-found.component';
import { MatDialog } from '@angular/material/dialog';
import { faCalendarDay } from '@fortawesome/free-solid-svg-icons';
import { SimyoDuplicadosSimService } from 'src/app/simyo/services/simyo-duplicados-sim.service';
import { masterAllResponseSimyo, masterAllSimyo } from 'src/app/simyo/models/masterAllSimyo';

@Component({
    selector: 'app-simyo-ds-listado',
    templateUrl: './simyo-ds-listado.component.html',
    styleUrls: ['./simyo-ds-listado.component.css', '../../../../../assets/css/simyo-theme.css'],
    standalone: false
})
export class SimyoDsListadoComponent implements OnInit {

    public orders: any[] = [];
    public ordersFiltered: any [] = [];
    public loaded: boolean = false;
    public isCollapsed: boolean = true;
    public errorSearch: boolean = false;
    public formGroup: FormGroup;
    public faCalendarDay = faCalendarDay;
    public master: masterAllSimyo;
    public minDate: moment.Moment;
    public maxDate: moment.Moment;
    public superStatus: any = superStatus;
    public superStatusTranslate: any = superStatusTranslate;
    public listSortByDate = listSortByDate;
    private automaticLoad: boolean = true;
    public lastPage: number = 0;
    public body: any = {
        limit: 50,
        page: 1,
        order: {
            created_at: 'desc'
        }
    };
    public pages: number[] = [];
    public statuses: any[] = [
        { id: '', value: 'Todas'},
        { id: 'active', value: 'Activado'},
        { id: 'in_process', value: 'En progreso'},
        { id: 'error', value: 'Error de procesamiento'}
    ]
    public simyoDocStatus = simyoDocStatus;
    public typeCard = typeCard;
    public superStatusOptions: any[] = [{ super_status_id: "Todas", value: "" }];
    
    constructor(
        private formBuilder: FormBuilder,
        private simyoService: SimyoService,
        private dialog: MatDialog,
        private simyoSimSwapService: SimyoDuplicadosSimService
    ) { }

    ngOnInit(): void {
        this.formGroup = this.formBuilder.group({
            full_name: [''],
            document: [''],
            msisdn_movil: [''],
            min_date: [''],
            max_date: [''],
            status: [''],
            sort_by_date: ['desc']
        });

        this.simyoService.getMasterAllFromService()
            .subscribe((data: masterAllResponseSimyo) => {
                if (data && data.msg) {
                    this.master = data.msg;
                }
            });

        this.getOrders();
    }

    advanceSearch() {
        // this.isAlertView = false;
        const formData = this.formGroup.getRawValue();
        const filters: any = {};

        if (formData.full_name !== '') {
            filters.customer_full_name = formData.full_name;
        }
        if (formData.document !== '') {
            filters.customer_document = formData.document;
        }
        if (formData.msisdn_movil !== '') {
            filters.mobile_msisdn = formData.msisdn_movil;
        }
        if (formData.status) {
            filters.statuses = [formData.status];
        }
        if (formData.sort_by_date) {
            this.body.order.created_at = formData.sort_by_date;
        }
        if (formData.min_date != null && formData.max_date != null && formData.min_date !== '' && formData.max_date !== '') {
            filters.date = 'bt|' + moment(formData.min_date).format('YYYY-MM-DD 00:00:00') + '|' + moment(formData.max_date).format('YYYY-MM-DD 23:59:59');
        } else if (formData.min_date != null && formData.min_date !== '') {
            filters.date = 'gte|' + moment(formData.min_date).format('YYYY-MM-DD 00:00:00');
        } else if (formData.max_date != null && formData.max_date !== '') {
            filters.date = 'lte|' + moment(formData.max_date).format('YYYY-MM-DD 23:59:59');
        }

        this.body.page = 1;
        this.body.filters = filters;
        this.orders = [];
        this.ordersFiltered = [];
        this.automaticLoad = true;

        this.getOrders();
    }

    getOrders() {
        this.loaded = false;
        this.errorSearch = false;
        this.simyoSimSwapService.listSimSwap(this.body)
            .subscribe((data: any) => {
                this.processData(data);
            }, (error) => {
                this.errorSearch = true;
                this.loaded = true;
                if (error && error.error && error.error.error && error.error.error.errorCode !== null && error.error.error.errorCode === 462) {
                    this.dialog.open(UserNotFoundComponent, {
                        width: '350px',
                        disableClose: true,
                        data: {
                            marca: 'Simyo'
                          }
                    });
                }
            });
    }

    processData(data: any) {
        this.loaded = true;
        this.orders = this.orders.concat(data.msg.data);
        this.ordersFiltered = this.orders;
        this.lastPage = data.msg.last_page;
        this.pages = Array(this.lastPage).fill(1).map((x, i) => i);
    }

    @HostListener('window:scroll', ['$event'])
    doSomethingOnWindowScroll(event: Event) {
        if (this.automaticLoad) {
            const element: any = event.srcElement;
            const scrollOffset = element.children[0].scrollTop;
            const windowHeight = document.documentElement.scrollHeight - window.innerHeight - 200;

            if (scrollOffset > windowHeight && windowHeight > 0) {
                console.log('Cargando siguiente página. A partir de ahora se carga en manual.');
                this.automaticLoad = false;
                this.nextPage();
            }
        }
    }

    nextPage() {
        if (this.body.page < this.lastPage) {
            this.body.page += 1;
            this.getOrders();
        }
    }

    loadMore() {
        this.nextPage();
    }

    searchClient(text) {
        this.ordersFiltered = this.orders.filter(item => {
            const fullName: string = item.first_name.toLowerCase() + ' ' +  item.last_name.toLowerCase() + ' ' + item.second_last_name.toLowerCase();
            const fullNameNormalized = fullName.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
            let document: string;

            if (item.document_number) {
                document = item.document_number.toLowerCase();
            }

            return document ? fullName.includes(text.toLowerCase()) || fullNameNormalized.includes(text.toLowerCase()) ||
                document.includes(text.toLowerCase()) : fullName.includes(text.toLowerCase()) ||
                fullNameNormalized.includes(text.toLowerCase());
        });
    }

    setMinDate(event: moment.Moment) {
        this.minDate = event;
    }

    setMaxDate(event: moment.Moment) {
        this.maxDate = event;
    }

    convertDate(data): string {
        return moment(data).format('DD/MM/YYYY, HH:mm');
    }

    convertStatusClass(status): string {
        switch (status) {
            case superStatus.active:
                return 'dot-complete';
            case superStatus.cancelled:
            case superStatus.error:
            case superStatus.rejected:
                return 'dot-cancel';
            default:
                return 'dot-pending';
        }
    }

    convertDocStatusClass(status): string {
        switch (status) {
            case simyoDocStatus.ok:
                return 'dot-complete';
            case simyoDocStatus.ko:
                return 'dot-cancel';
            default:
                return 'dot-pending';
        }
    }
}
